var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 135,
    viewBox: "0 0 140 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.645 74.3938C142.502 54.9668 127.761 44.4534 107.42 37.4826L114.048 11.0848L98.0489 7.08512L91.6495 32.7972C87.4213 31.7688 83.0788 30.7403 78.7363 29.8261L85.1357 3.99966L69.1371 0L62.6233 26.2835C59.0808 25.4836 55.6525 24.6836 52.3385 23.8837V23.7694L30.1689 18.2842L25.9407 35.4256C25.9407 35.4256 37.8254 38.1682 37.5968 38.2825C44.1106 39.8824 45.2534 44.2249 45.0248 47.6531L37.4826 77.7078C37.9397 77.822 38.5111 77.9363 39.1967 78.2791C38.6253 78.1649 38.054 78.0506 37.4826 77.822L26.9692 119.876C26.1692 121.818 24.1123 124.79 19.6555 123.647C19.7698 123.875 7.99933 120.79 7.99933 120.79L0 139.188L20.9125 144.445C24.7979 145.474 28.569 146.388 32.3401 147.416L25.7121 174.043L41.7108 178.042L48.3388 151.644C52.6813 152.787 57.0238 153.93 61.1377 154.958L54.624 181.242L70.6227 185.242L77.2507 158.615C104.677 163.758 125.247 161.701 133.817 136.903C140.788 117.019 133.475 105.477 119.076 97.9346C129.703 95.5348 137.589 88.564 139.645 74.3938ZM102.963 125.818C98.0489 145.702 64.4517 134.96 53.5955 132.217L62.3948 96.9062C73.251 99.6488 108.22 105.02 102.963 125.818ZM107.991 74.0509C103.42 92.2208 75.5365 82.9645 66.5087 80.6789L74.5081 48.6816C83.5359 50.9672 112.676 55.1954 107.991 74.0509Z",
    fill: "url(#paint0_linear_1_452)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_452",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 185.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.85358c8058864bd429d6629072dd50ac.svg";
export { ForwardRef as ReactComponent };